export const ViewDataLabelMap = {
    freeTextData: 'Free Text',
    searchData: 'Search',
    formData: 'Form'
};
//# sourceMappingURL=types.js.map